import React, { useEffect, useRef, useState } from 'react'
import { formattedDate } from '../../utils/formattedDate';

const EditSlider = ({ profileData, LazyImage }) => {

  return (
    <div className='founder-basic-info'>
      <div className='founder-edit-section'>
        <div className='founder-profile-image'>
          <LazyImage
            src={profileData?.profileImg}
            alt="founder"
          />
        </div>
      </div>
      <div className='founder-position'>
        <div className='founder-name'>{profileData?.name}</div>
        {profileData?.type === 1 ? (
          <div className="founder-type">Founder</div>
        )
          : profileData?.type === 2 ? (
            <div className='angel-type'>Angel</div>
          ) : profileData?.type === 3 ? (
            <div className='vc-type'>VC</div>
          ) : (
            <div className='accelerators-type'>Accelerator</div>
          )
        }

        {profileData?.type === 1 ?
          profileData?.step === 0 ? (
            <div className="founder-status">Active</div>
          ) : (
            <div className="founder-nc-status">Not Completed</div>
          ) : profileData?.step === 0 ? (
            <div className='user-status'>Active {profileData?.priceId ? `(${profileData?.priceId?.slice(6)})` : ""}</div>
          ) : (
            <div className="user-nc-status">Not Completed {profileData?.priceId ? `(${profileData?.priceId?.slice(6)})` : ""}</div>
          )
        }

      </div>
      <div className='founder-date'>Registered on {formattedDate(profileData?.createdAt)}</div>
    </div>
  );

}

export default EditSlider;
